// extracted by mini-css-extract-plugin
export var avatarContainer = "_9o-0";
export var avatarTypingWave = "_9o-i";
export var gray = "_9o-f";
export var green = "_9o-c";
export var icon = "_9o-9";
export var image = "_9o-1";
export var lg = "_9o-6";
export var md = "_9o-5";
export var presenceDot = "_9o-b";
export var red = "_9o-d";
export var sm = "_9o-4";
export var status = "_9o-a";
export var typingDot = "_9o-h";
export var typingPill = "_9o-g";
export var xl = "_9o-7";
export var xs = "_9o-3";
export var xxl = "_9o-8";
export var xxs = "_9o-2";
export var yellow = "_9o-e";